import React from 'react';
import YouTube from 'react-youtube';
import * as actions from '../Actions';
import ShareOptions from '../ShareOptions';

export default function ({ feedItem, GTMlike, gtmShare }) {
    return (

<div className="main_block_container_feed video-component">
                           <div className="block_container_feed_heading_text R15_61">
                             {/* <span className="dny-b-15"> Video </span> */}
                             {feedItem.title?feedItem.title:''} </div>
                             <div className='content-div-box-artical'>
                            <div className="content-div_view_artical" rel={feedItem.data[0].url?feedItem.data[0].url:''}>
                                {/*<img src={feedItem.icon} alt="logo"/>*/}
                                {feedItem.data && feedItem.data[0].url &&
                                    <YouTube videoId={feedItem.data[0].url.split('=')[1]} height="360" width="500" />
                                }
                            </div>
                         <div className="baby-week-social-view hightlighted-social-view">  
                            <div className="post-options">
                              <div className="icon left devMemoLike font-sizeview" data-icon-font="$"> <span className="icons-text R13_61">{feedItem.data[0].view_count?feedItem.data[0].view_count:''}</span> </div>
                            <div className={feedItem.data[0].isLiked ? "left likeicon isliked active" : "left likeicon"} > 
                                <span className={`icon likesIcon ${GTMlike}`}  data-icon-font="" onClick={(e) => actions.saveVideoAction(feedItem.data[0].id, e, "like", feedItem.data[0].isLiked ? 0 : 1,feedItem.data[0].like_count)}></span> 
                                <span className="icons-text R13_61" onClick={(e) => actions.getAnswerLikeUsersArticle(e,feedItem.data[0].id, feedItem.data[0].like_count)}>{feedItem.data[0].like_count?feedItem.data[0].like_count:''} <span className='mLike'>Likes </span></span> 
                            </div>
                            </div>
                            <div className="m-abuse-main right" id={`share_${feedItem.data[0].id}`}>
                                <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                                <div className="icon left icon3dot whatsapp-icons" data-icon-font=""> <span className={`icons-text R14_61 cursor-pointer ${gtmShare}`} onClick={() => actions.shareOn(feedItem.data[0].id)}> Share </span></div>
                                <ShareOptions feedItem={feedItem} eleRef={this} />
                            </div>
                            </div>

                             </div> 
                    </div>
    )
}